// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxHC5WpYEsSArf3nEWqeMrK4X3f5tvU1c",
  authDomain: "family-hub-9ae4e.firebaseapp.com",
  projectId: "family-hub-9ae4e",
  storageBucket: "family-hub-9ae4e.firebasestorage.app",
  messagingSenderId: "252081832389",
  appId: "1:252081832389:web:17df384be0ef4563c98bac",
  measurementId: "G-5RN3R08J1V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (disabled by default for COPPA compliance)
// Analytics will be enabled ONLY for parent accounts (18+)
const analytics = getAnalytics(app);
setAnalyticsCollectionEnabled(analytics, false); // Disabled by default

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functionsInstance = getFunctions(app, 'us-central1');

export { app, analytics, auth, db, storage, functionsInstance };
